// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"21db00fb","239":"01786824","389":"c756036a","455":"cbec526f","719":"c98aae86","977":"db510a6c"}[chunkId] + ".chunk.js";
};